import axios from 'axios';

export default {
    pre_insercion_corredor(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_contactos.pre_insercion_ConCorr",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_corredor(p_email, p_codcorredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.fnc_consultacorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_codcorredor,
				})
		})
	},
	
	eliminar_ConCorr(p_email, p_usuario,p_codcorredor, p_mail){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_compp_contactos.eliminar_ConCorr",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_codcorredor": p_codcorredor,
				"p_mail": p_mail
                })
        })
    },

	editar_ConCorr(p_email, p_usuario, p_codcorredor, p_contacto, p_mail_old, p_mail, p_rli, p_rpr){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.editar_ConCorr",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_codcorredor": p_codcorredor,
				"p_contacto": p_contacto,
				"p_mail_old": p_mail_old,
				"p_mail": p_mail,
				"p_rli"     : p_rli,
				"p_rpr"     : p_rpr				
			     })
		});
	},

	recuperar_ConCorr(p_email, p_codcorredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.recuperar_ConCorr",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_codcorredor
				})
		})
	},

	pre_insercion_CorrPol(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_contactos.pre_insercion_CorrPol",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	recuperar_CorrPol(p_email, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.recuperar_CorrPol",
			"p_args_in": JSON.stringify({
				"p_poliza": p_poliza
				})
		})
	},

	consulta_CorrPol(p_email, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.consulta_CorrPol",
			"p_args_in": JSON.stringify({
				"p_poliza": p_poliza,
				})
		})
	},

	editar_CorrPol(p_email, p_usuario, p_poliza, p_codcorredor, p_contacto, p_mail_old, p_mail, p_rli, p_rpr){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.editar_CorrPol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_codcorredor": p_codcorredor,
				"p_contacto": p_contacto,
				"p_mail_old": p_mail_old,
				"p_mail": p_mail,
				"p_rli": p_rli,
				"p_rpr": p_rpr		
			     })
		});
	},	


}